import { Link } from 'react-router-dom'
import SmallLogo from '../assets/logo/small_Logo.png'
import SocialIcons from './SocialIcons'
export default function Footer() {
  return (
    <footer className="bg-primary-footer backdrop-blur-3xl text-gray-700">
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 pt-10">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white  p-1 rounded">
                <img src={SmallLogo} className='h-6' alt="" />
              </div>
              <span className="text-2xl font-bold">Codecube Technology</span>
            </div>
            <p className="max-w-md leading-relaxed">
              Building fast, delightful digital products with cutting-edge technology, 
              modern stack, and exceptional user experience. Transforming ideas into 
              scalable digital solutions.
            </p>
           {/* social file import below  */}
              <SocialIcons />
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link className=" hover:text-gray-400 transition-colors duration-300" to="/about">About Us</Link></li>
              <li><Link className=" hover:text-gray-400 transition-colors duration-300" to="/vision">Our Vision</Link></li>
              <li><Link className=" hover:text-gray-400 transition-colors duration-300" to="/contact">Contact</Link></li>
              <li><Link className=" hover:text-gray-400 transition-colors duration-300" to="/careers">Careers</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-3 flex flex-col">
              <Link to='/services/digital-marketing' className=" hover:text-gray-400 transition-colors duration-300 cursor-pointer">Digital Marketing</Link>
              <Link to='/services/web-development' className=" hover:text-gray-400 transition-colors duration-300 cursor-pointer">Web Development</Link>
              <Link to='/services/app-development' className=" hover:text-gray-400 transition-colors duration-300 cursor-pointer">App Development</Link>
              <Link to='/services/it-support' className=" hover:text-gray-400 transition-colors duration-300 cursor-pointer">IT Support</Link>
              <Link to='/services/cloud' className=" hover:text-gray-400 transition-colors duration-300 cursor-pointer">Cloud Solutions</Link>
            </ul>
          </div>
        </div>

        <div className="mt-12 py-4 border-t-2 border-gray/20 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-black font-semibold text-sm">© {new Date().getFullYear()} Codecube Technology. All rights reserved.</p>
          <div className="inline-flex items-center gap-4">
            <Link to="/privacy-policy" className="text-blue-600 hover:text-white text-sm transition-colors duration-300">Privacy Policy</Link>
            <span className="text-blue-600">•</span>
            <Link to="/terms-of-service" className="text-blue-600 hover:text-white text-sm transition-colors duration-300">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}